import AppMenu from './Menus/AppMenu';
import UserMenu from './Menus/UserMenu';
import PagesMenu from './Menus/PagesMenu';
import BlogsMenu from './Menus/BlogsMenu';
import AssetsMenu from './Menus/AssetsMenu';

import { flatJoinLists } from 'Core/Utils';

function MainMenu (appState = {}) {
  return flatJoinLists([
    AppMenu(appState),
    PagesMenu(appState),
    BlogsMenu(appState),
    AssetsMenu(appState),
    UserMenu(appState)
  ], { divider: true });
};

export default MainMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/MainMenu.js